import React, { useEffect, useState } from 'react';
import type { Video } from '../types/video';
interface HeroImageProps {
  video: Video;
}

// YouTube doesn't create maxres/sd thumbnails for every upload. For missing sizes it
// still returns a tiny grey 120×90 placeholder (so onError doesn't always fire),
// therefore we also check the loaded size and step down to the next quality.
function candidates(video: Video): string[] {
  const base = `https://i.ytimg.com/vi/${video.id}`;
  return [...(video.cover ? [video.cover] : []), `${base}/maxresdefault.jpg`, `${base}/sddefault.jpg`, `${base}/hqdefault.jpg`];
}
export function HeroImage({
  video
}: HeroImageProps) {
  const sources = candidates(video);
  const [index, setIndex] = useState(0);
  useEffect(() => setIndex(0), [video.id, video.cover]);
  const next = () => setIndex(i => i < sources.length - 1 ? i + 1 : i);
  return <img key={sources[index]} src={sources[index]} alt="" onError={next} onLoad={e => {
    if (e.currentTarget.naturalWidth <= 120) next();
  }} className="absolute inset-0 -z-20 h-full w-full bg-surface object-cover" data-id="element-59" data-mp="1u2chbxsxdkln" />;
}